// time should be a string specified in one of the following formats:
// hour/min/sec: 2:33:44.123
// min/sec:        33:44.123
// sec only:          44.123
// large seconds:   9224
// decimal part of seconds is optional
// returns a float; returns NaN if time is invalid
const parseTimeIntoSeconds = (time: number | string): number => {
  enum TimeFormat {
    SECONDS,
    MINUTES_SECONDS,
    HOURS_MINUTES_SECONDS,
  }

  if (!time) {
    return NaN;
  }

  if (typeof time === 'number') {
    return time / 1000;
  }

  const parsedTime = time.split(':');
  const colonCount = parsedTime.length - 1;
  const [seconds, minutes, hours] = parsedTime.reverse();
  switch (colonCount) {
    case TimeFormat.SECONDS:
      return +time;
    case TimeFormat.MINUTES_SECONDS:
      return +minutes * 60 + +seconds;
    case TimeFormat.HOURS_MINUTES_SECONDS:
      return +hours * 3600 + +minutes * 60 + +seconds;
    default:
      return NaN;
  }
};

export default parseTimeIntoSeconds;
